import React from 'react'

const withContainer = Component => ({ task }) => {
  const fails_count = _.size(task?.result?.fails)
  const incorrects_count = _.size(task?.result?.incorrects)
  const success_count = _.size(task?.result?.success)
  const total = _.size(task?.input?.orders)

  const mergedProps = {
    fails_count,
    incorrects_count,
    success_count,
    total
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
